import axios from "~/axios";
import i18n from "~/i18n/index";

export default {
  state: {
    user: null,
    user_loading: null,
    is_authenticated: false,
  },
  getters: {
    user(state) {
      return state.user;
    },
    user_loading(state) {
      return state.user_loading;
    },
    isAuthenticated(state) {
      return state.is_authenticated;
    },
  },
  actions: {
    async setUser({ commit, rootState }, user) {
      if (!user) {
        commit("SET_USER", null);
        commit("AUTHENTICATE", false);
        return;
      }
      commit("USER_LOADING", true);

      axios.defaults.headers.common["Authorization"] = `Bearer ${user.access_token}`;
      user.profile.institution = await setInstitution(rootState, user.profile);
      commit("SET_USER", user.profile);
      commit("USER_LOADING", false);
    },
  },
  mutations: {
    async SET_USER(state, payload) {
      state.user = payload;
      state.is_authenticated = true;
    },
    USER_LOADING(state, payload) {
      state.user_loading = payload;
    },
    AUTHENTICATE(state, value) {
      state.is_authenticated = value;
    },
  },
};

async function setInstitution(rootState, profile) {
  if (!profile) {
    return;
  }
  const vopersonExternalId = Array.isArray(profile.voperson_external_id)
    ? profile.voperson_external_id[0]
    : profile.voperson_external_id;
  if (!vopersonExternalId) {
    return;
  }
  const institutionId = vopersonExternalId.split("@")[1] ?? vopersonExternalId;

  const locale = i18n.locales.find((x) => x.code == i18n.locale).iso;
  const query = {
    query: `query {
          institutions(filter: { name: { _eq: "${institutionId}"}, participating: { _eq: true } } ) {
              id
              name
              translations(filter: { languages_code: { code: { _eq: "${locale}" } } }) {
                  name
              }
            }
        }`,
  };
  const url = rootState.config.config.cms_api_endpoint;
  const { data } = await axios.post(url, query, {
    headers: {
      authorization: null, // dont send bearer token because directus will check it and fail
    },
  });
  if (data.data.institutions.length) {
    return data.data.institutions[0].translations[0].name;
  } else {
    return institutionId;
  }
}
